import { useEffect, useState } from "react";
import { Carousel, Container, ProgressBar } from "react-bootstrap";
import "./css/style.css";
import { InputMask } from "@react-input/mask";
import { KwizGo } from "../../axi";
// import ReactInputMask from "react-input-mask";

export default function Kwiz() {
    const [indexGo, setIndexGo] = useState(0);
    const [progress, setProgress] = useState(0);
    const [nextBut, setNextBut] = useState(true);

    const [formData, setFormData] = useState({
        mesto: "",
        mesto_ekran: "",
        razmer: "",
        razmer_hz: "",
        name: "",
        tel: "",
    });
    const [formGo, setFormGo] = useState(false);

    const handleSelect = (selectedIndex, e) => {
        setIndexGo(selectedIndex);
    };

    const nextChange = (e) => {
        if (nextBut) {
            setIndexGo((prevIndex) => prevIndex + 1);
        }
        setNextBut(false);
    };

    const prevSlide = () => {
        setIndexGo((prevIndex) => (prevIndex === 0 ? 2 : prevIndex - 1));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // Обработчик для чекбокса
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: checked ? "Клиент не знает" : "",
            razmer: checked ? "" : prevFormData.razmer, // Обнуляем значение поля ввода, если чекбокс отмечен
        }));
    };

    // Обработчик для поля ввода
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
            razmer_hz: value ? "" : prevFormData.razmer_hz, // Снимаем чекбокс, если в поле ввода есть значение
        }));
    };

    // Обрабатываем отправку
    const handleSubmit = async (e) => {
        e.preventDefault();

        const isKwizSub = await KwizGo(formData);

        if (isKwizSub) {
            // Отправляем событие в Яндекс.Метрику
            if (typeof window !== 'undefined' && window.ym) {
                window.ym(99807460,'reachGoal','quiz_completed');
            }
            // Выполните действия, если вход успешен
            setFormGo(true);
            setIndexGo((prevIndex) => prevIndex + 1);

            setTimeout(() => {
                setFormGo(false);
            }, 2000);
        } else {
            // Выполните действия, если вход неуспешен
        }
    };

    useEffect(() => {
        let formKeys = Object.keys(formData);
        if (formData[formKeys[indexGo - 1]] || indexGo === 0) {
            setNextBut(true);
        }
        if (formData[formKeys[3]] !== "") {
            setNextBut(true);
        }

        console.log(formData);
    }, [formData, indexGo]);

    useEffect(() => {
        const totalSteps = 5; // Фиксированное количество шагов
        const newProgress = Math.round((indexGo / totalSteps) * 100);
        setProgress(newProgress);
    }, [indexGo]);

    /*МАСКА ДЛЯ НОМЕРА ТЕЛЕФОНА*/
    const getInputNumbersValue = function (input) {
        return input.value.replace(/\D/g, "");
    };
    const onPhonePaste = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData || window.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData("Text");

            if (/\D/g.test(pastedText)) {
                // Attempt to paste non-numeric symbol — remove all non-numeric symbols,
                // formatting will be in onPhoneInput handler
                input.value = inputNumbersValue;
                return;
            }
        }
    };
    const onPhoneKeyDown = function (e) {
        // Clear input after remove last symbol
        console.log("onPhoneKeyDown", e.keyCode);

        let inputValue = e.target.value.replace(/\D/g, "");
        if (e.keyCode === 8 && inputValue.length === 1) {
            e.target.value = "";
        }
    };
    const onPhoneInput = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return (input.value = "");
        }

        if (input.value.length !== selectionStart) {
            // Editing in the middle of input, not last symbol
            if (e.data && /\D/g.test(e.data)) {
                // Attempt to input non-numeric symbol
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols = inputNumbersValue[0] == "8" ? "8" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = "+" + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
    };
    return (
        <section id="kwiz" className="kwiz">
            <Container className="sect">
                <form onChange={handleChange} onSubmit={handleSubmit} action="">
                    <Carousel activeIndex={indexGo} controls={false} interval={null} indicators={false} className="kwiz_plot">
                        <Carousel.Item className="kwiz_item">
                            <div className="kwiz_hellow">
                                <div>
                                    <h2>Узнайте стоимость LED экрана для ваших нужд за 1 минуту!</h2>
                                    <p className="t24">Ответьте на 3 простых вопроса и получите индивидуальный расчет стоимости под ваши запросы.</p>
                                </div>
                                <div className="imgContainer">
                                    <img className="kwiz_picture" src="/img/kwiz/picture.png" alt="картинка" />
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="kwiz_item">
                            <div className="">
                                <p className="h2">
                                    Где вы хотите <br /> разместить экран?
                                </p>
                                <div className="kwiz_item_inpBox -g flex">
                                    <label className="kwiz_item_chek t20 flex" htmlFor="mesto-1">
                                        <div className="kwiz_item_chek_text flex">
                                            <input
                                                type="radio"
                                                id="mesto-1"
                                                name="mesto"
                                                className="kwiz_item_chek_input"
                                                value="в помещении"
                                                onChange={handleChange}
                                            />
                                            В помещении
                                        </div>
                                        <img src="/img/kwiz/picture2.png" alt="" />
                                    </label>
                                    <label className="kwiz_item_chek t20 flex" htmlFor="mesto-2">
                                        <div className="kwiz_item_chek_text flex">
                                            <input
                                                type="radio"
                                                id="mesto-2"
                                                name="mesto"
                                                className="kwiz_item_chek_input"
                                                value="На улице"
                                                onChange={handleChange}
                                            />
                                            На улице
                                        </div>
                                        <img src="/img/kwiz/picture1.png" alt="" />
                                    </label>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="kwiz_item">
                            <div className="">
                                <p className="h2">
                                    Расположение <br />
                                    {formData.mesto === "в помещении" ? "в помещении" : "на улице"}
                                </p>
                                <div className="kwiz_item_inpBox -g flex">
                                    <label className="kwiz_item_chek t20 flex" htmlFor="mesto_ekran-1">
                                        <div className="kwiz_item_chek_text flex">
                                            <input
                                                type="radio"
                                                id="mesto_ekran-1"
                                                name="mesto_ekran"
                                                className="kwiz_item_chek_input"
                                                value={formData.mesto === "в помещении" ? "На стене" : "На фасаде здания"}
                                                onChange={handleChange}
                                            />
                                            {formData.mesto === "в помещении" ? "На стене" : "На фасаде здания"}
                                        </div>
                                    </label>
                                    <label className="kwiz_item_chek t20 flex" htmlFor="mesto_ekran-2">
                                        <div className="kwiz_item_chek_text flex">
                                            <input
                                                type="radio"
                                                id="mesto_ekran-2"
                                                name="mesto_ekran"
                                                className="kwiz_item_chek_input"
                                                value={formData.mesto === "в помещении" ? "На полу" : "На земле"}
                                                onChange={handleChange}
                                            />
                                            {formData.mesto === "в помещении" ? "На полу" : "На земле"}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="kwiz_item">
                            <div className="">
                                <p className="h2">какой размер необходим?</p>
                                <div className="kwiz_item_inpBox -g flex">
                                    <input
                                        placeholder="Укажите размер"
                                        className="kwiz_inText"
                                        required=""
                                        type="text"
                                        name="razmer"
                                        value={formData.razmer}
                                        onChange={handleInputChange}
                                    />
                                    <label className="kwiz_item_chek t20 flex" htmlFor="razmer_hz">
                                        <div className="kwiz_item_chek_text flex">
                                            <input
                                                className="kwiz_item_chek_input"
                                                type="checkbox"
                                                id="razmer_hz"
                                                name="razmer_hz"
                                                value="Клиент не знает"
                                                checked={formData.razmer_hz === "Клиент не знает"}
                                                onChange={handleCheckboxChange}
                                            />
                                            Не знаю
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="kwiz_item">
                            <div>
                                <p className="h2">спасибо, мы получили ваши ответы!</p>
                                <p className="t24">Оставьте контактные данные, чтобы наш менеджер связался с вами.</p>
                                <div className="">
                                    <input
                                        placeholder="ИМЯ*"
                                        className="kwiz_inText"
                                        required
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />{" "}
                                    <br />
                                    <input
                                        onInput={onPhoneInput}
                                        onKeyDown={onPhoneKeyDown}
                                        onPaste={onPhonePaste}
                                        required
                                        class="form__input form__input--tel js-req popup_phone"
                                        data-tel-input
                                        id="phoneInput"
                                        name="tel"
                                        type="tel"
                                        className="kwiz_inText"
                                        placeholder="+7 (___) ___-__-__"
                                        maxlength="18"
                                    />
                                    <br />
                                    <button className="button" type="submit">
                                        рассчитать проект
                                    </button>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="kwiz_item ">
                            <div className="flex" style={{ margin: "13%" }}>
                                <p className="h2" style={{ textAlign: "center" }}>
                                    мы внимательно изучим ваши пожелания и в скором времени перезвоним
                                </p>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </form>
                <div className="kwiz_controller">
                    <div className="kwiz_controller_progress">
                        <p className="t20">
                            Готово: <span className="kwiz_controller_proc">{progress} %</span>
                        </p>
                        <ProgressBar className="kwiz_controller_bar" now={progress} />
                    </div>
                    <div className="kwiz_controller_menu">
                        {indexGo < 5 && (
                            <div onClick={prevSlide} className={`kwiz_controller_back ${indexGo > 0 ? "active" : ""}`}>
                                <img src="/img/icon/left.svg" alt="" />
                            </div>
                        )}
                        {indexGo < 4 && (
                            <button onClick={nextChange} className={`button ${nextBut ? "active" : ""}`}>
                                {indexGo > 0 ? "Далее" : "начать"}
                            </button>
                        )}
                    </div>
                </div>
            </Container>
        </section>
    );
}
